import { rackSizeOptions } from "@/common/const";
import { includedOptions } from "@/common/const/filter-options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { ResponseFormElementsType } from "@/common/types/forms/FormFieldsStrategy.type";

const dcRackResStrategy: ResponseFormElementsType[] = [
  {
    type: "text",
    attribute: "provider",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "power",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^[0-9]+(\.[0-9]+)?$/, 
    patternMessage: "Power must be a valid number.",
  },
  {
    type: "select",
    attribute: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "select",
    attribute: "isLocalTax",
    required: true,
    options: includedOptions,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "quantity",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^[0-9]+$/, 
    patternMessage: "Quantity must be a valid number.",
  },
  {
    type: "text",
    attribute: "localTax",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^[0-9]+(\.[0-9]+)?$/, 
    patternMessage: "Local tax must be a valid number.",
  },
  {
    type: "select",
    attribute: "rackSize",
    required: true,
    options: rackSizeOptions,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "leadTeam",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^\d{1,3}$/,
    patternMessage: "Lead time must be a number (days)",
  },
];
export default dcRackResStrategy;
